export function ensureHttpsUrl(url: string): string {
  if (!url || url.trim() === '') {
    return url;
  }

  const trimmedUrl = url.trim();

  if (trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }

  if (trimmedUrl.startsWith('http://')) {
    return trimmedUrl.replace(/^http:\/\//, 'https://');
  }

  return `https://${trimmedUrl}`;
}

function asMetadataRecord(value: unknown): Record<string, unknown> | undefined {
  return typeof value === 'object' && value !== null
    ? (value as Record<string, unknown>)
    : undefined;
}

export function getMetadataSolanaDappStore<T>(
  metadata: unknown,
): T | undefined {
  const record = asMetadataRecord(metadata);
  const extensions = asMetadataRecord(record?.extensions);
  return asMetadataRecord(extensions?.solana_dapp_store) as T | undefined;
}

export function getTokenReleaseSolanaDappStore<T>(
  tokenJson: unknown,
): T | undefined {
  const tokenData = asMetadataRecord(asMetadataRecord(tokenJson)?.data);
  const nftRelease = asMetadataRecord(tokenData?.nft_release);
  return getMetadataSolanaDappStore<T>(nftRelease);
}

export function ensureIconInMediaArray<T extends { purpose: string }>(
  mediaArray: T[],
  iconUri?: string,
): void {
  const hasIcon = mediaArray.some((media) => media.purpose === 'icon');
  if (!hasIcon) {
    throw new Error(
      iconUri
        ? `NFT media array is missing required icon metadata for ${iconUri}`
        : 'NFT media array is missing a required icon asset.',
    );
  }
}

export function extractFilename(uri: string, maxLength = 20): string {
  if (!uri) return 'No filename';

  const filename = uri.split('/').pop();
  if (filename) return filename;

  return uri.substring(uri.length - maxLength);
}
